import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form'
import {Row, Form, Divider} from 'antd';
import {RTLCol,RTLButton} from '../RTLKit';

/* ------ Field -------- */
import TextField from '../formFields/TextField';

/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import jwtDecode from "jwt-decode";
import Loading from "../loading/loading";
import SelectField from "../formFields/SelectField";

class AddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: this.props.match.params.id ? 'edit' : 'add',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            formLayout: 'horizontal'
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
        this.props.getAreaStateList();
        if (this.props.match.params.id){
            let id = this.props.match.params.id;
            this.props.getItem(id)
        }
    }

    __getAreaStateList() {
        let areaList = this.props.areaList;
        let dataSource = [];

        if (areaList) {

            for (let i = 0; i < areaList.length; i++) {
                dataSource.push(
                    {label: areaList[i].title, value: areaList[i]._id, key: i}
                );
            }
        }
        return dataSource;
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;

        /*---- set mode ---*/
        if(this.props.initialValues) {
            this.props.initialValues.mode=this.state.mode
        }

        /*--- get state list for show in select box ---*/
        var stateList = this.__getAreaStateList();

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} >
                <Row>
                    <Divider orientation="left">{this.state.mode == 'edit' ? "ویرایش" : "ایجاد"} شهر</Divider>
                </Row>
                {this.state.mode == 'edit' ?
                    <Loading list={this.props.initialValues} />
                : null}
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>
                            <Field
                                name="title"
                                component={TextField}
                                type="text"
                                label="عنوان"
                                placeholder="عنوان"
                            />
                            <Field
                                name="code"
                                component={TextField}
                                type="text"
                                label="کد(اختیاری)"
                                placeholder="کد"
                            />
                            <Field
                                name="stateId"
                                component={SelectField}
                                label="استان"
                                list={stateList}
                                defaultValue={(this.props.initialValues && this.props.initialValues.state._id ? this.props.initialValues.state._id : null)}
                            />
                            <Field
                                name="commission"
                                component={TextField}
                                type="text"
                                label="پورسانت شرکت(ریال)"
                                placeholder="مبلغ پورسانت شرکت"
                            />
                            <Field
                                name="commuting_fee"
                                component={TextField}
                                type="text"
                                label="هزینه ایاب و ذهاب (ریال)"
                                placeholder="هزینه ایاب و ذهاب"
                            />
                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" >
                                {this.state.mode == 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton href="#/city/list" className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default AddEditForm = reduxForm({
    form: 'addCity',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(AddEditForm)
